<video class="video-private"
       #zwiftVideo
       autoplay
       playsinline
       muted
       disablepictureinpicture
       autopictureinpicture="false">
</video>
<canvas #canvas
        class="video-canvas"
></canvas>

